<div *ngIf="!showCart">
  <!-- Filter Section -->
  <div class="filter-section">
    <div class="filters">
      <label>
        Start Date:
        <input type="date" [(ngModel)]="startDate" />
      </label>

      <label>
        End Date:
        <input type="date" [(ngModel)]="endDate" />
      </label>
    </div>

    <div class="filter-buttons">
      <button mat-raised-button color="primary" (click)="applyFilter()">Apply Filter</button>
    </div>
  </div>

  <!-- Reusable Table Component -->
  <app-sales-orders-table [(orders)]="loadSalesOrders"           
                         (openOrder)="openOrder($event)"
                         (ordersChange)="onOrdersChange($event)">
  </app-sales-orders-table>

  <!-- Load Note (placed just above Create Load button) -->
  <div class="load-note" *ngIf="loadSalesOrders.length > 0" style="margin-top: 8px;">
    <label style="display:block;">
      Note:
      <input type="text" [(ngModel)]="note" placeholder="Optional note for this load" style="width:100%;" />
    </label>
  </div>

  <!-- Grand Total -->
  <div class="grand-total" *ngIf="loadSalesOrders.length > 0">
    <strong>Grand Total: {{ grandTotal | currency:'INR':'symbol':'1.2-2' }}</strong>
  </div>
    
  <!-- Create Load Button -->
  <div class="create-load-button" *ngIf="loadSalesOrders.length > 0">
    <button class="full-width" mat-raised-button color="primary" (click)="createLoad()">Create Load</button>
  </div>

  <!-- No Results Message -->
  <div *ngIf="loadSalesOrders.length === 0">
    <p>No sales orders available for the selected date range.</p>
  </div>
</div>

<!-- Cart View -->
<div *ngIf="showCart">
  <app-cart [selectedCustomer]="selectedCustomerFromList"
            [selectedProducts]="selectedProducts"
            [disableOrder]="true"
            [disableEdit]="true"
            [disableDelete]="true"
            [disableDraft]="true">
  </app-cart>

  <div class="close-details-button">
    <button mat-raised-button color="accent" class="full-width" (click)="showCart = false">
      Close Details
    </button>
  </div>
</div>
